/**
 * ClientSummaryTeaser — o conteúdo da aba "Histórico" do diálogo de edição.
 *
 * Substitui a antiga `ClientHistorySection`, que renderizava a lista inteira
 * dentro do modal. O histórico agora tem página própria (`/clients/:id`) e a
 * renderização mora SÓ lá: manter duas versões da mesma lista era garantia de
 * elas divergirem (foi assim que o `navigate('/orcamentos/:id')` quebrado ficou
 * despercebido).
 *
 * O diálogo continua sendo o lugar de EDITAR o cliente; daqui só se sai para o
 * resumo.
 */
import { Card, CardContent } from '@/components/ui/card';
import { Button3D } from '@/components/ui/button-3d';
import { History } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ClientSummaryTeaserProps {
  clientId: string;
  /** Fechar o diálogo antes de navegar, senão o modal fica montado por baixo. */
  onNavigate?: () => void;
}

export function ClientSummaryTeaser({ clientId, onNavigate }: ClientSummaryTeaserProps) {
  const navigate = useNavigate();

  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center gap-3 py-8 text-center">
        <History className="h-12 w-12 text-muted-foreground/50" />
        <div>
          <p className="font-medium">Resumo do cliente</p>
          <p className="mt-1 text-sm text-muted-foreground">
            Orçamentos, vendas, ordens de serviço, contratos, recibos e o que está em aberto — tudo
            numa linha do tempo só.
          </p>
        </div>
        <Button3D
          onClick={() => {
            onNavigate?.();
            navigate(`/clients/${clientId}`);
          }}
        >
          Ver resumo completo
        </Button3D>
      </CardContent>
    </Card>
  );
}
